"use client";

import { useId } from "react";

/** Soft orange glow — Figma Ellipse 8 (testimonials) */
const TestimonialsGlow = ({ className }: { className?: string }) => {
    const filterId = useId().replace(/:/g, "");

    return (
        <svg
            className={className}
            viewBox="0 0 1317 1317"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <g opacity="0.5" filter={`url(#${filterId})`}>
                <circle cx="658.5" cy="658.5" r="158.5" fill="#F47843" />
            </g>
            <defs>
                <filter
                    id={filterId}
                    x="0"
                    y="0"
                    width="1317"
                    height="1317"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="250" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    );
};

export default TestimonialsGlow;
